import React from "react";
import { BadgeCheck } from "lucide-react";

/** Compact "Trusted by Verified Parents" badge shown on schools whose
 *  verified_ratio >= 50% (and at least 2 verified reviews). */
export default function TrustedBadge({ school, size = "sm" }) {
  if (!school?.trusted) return null;
  const pad = size === "lg" ? "px-3 py-1.5" : "px-2 py-0.5";
  const textSize = size === "lg" ? "text-xs" : "text-[10px]";
  return (
    <span
      data-testid="trusted-badge"
      title={`Rasio review wali terverifikasi: ${school.verified_ratio}%`}
      className={`inline-flex items-center gap-1 ${pad} rounded-full bg-[#DCFCE7] text-[#166534] ${textSize} uppercase tracking-wider border border-[#BBF7D0] font-semibold`}
    >
      <BadgeCheck size={size === "lg" ? 12 : 10} />
      {size === "lg" ? "Trusted by Verified Parents" : "Trusted"}
    </span>
  );
}
